import { useCopies } from "shared/hooks/useCopies";

export function BulkTicketAssignedParticipantsTable(props: {
  tableRef: React.MutableRefObject<any>;
  isInModal?: boolean;
  children: React.ReactNode;
}) {
  const copies = useCopies();
  return (
    <div className="blkTicketParticipants_listing">
      <div className="blkTicketParticipants_header">
        <span className="blkTicketParticipants_headerTitle">{copies.get("bulk.ticket.assigned.tickets")}</span>
        <span className="blkTicketParticipants_headerSearch">{props.tableRef?.current?.SearchBox}</span>
      </div>
      <div className="blkTicketParticipants_tableWrapper">{props.children}</div>
    </div>
  );
}
